export default __webpack_public_path__ + "static/media/ai2.2ddd2d7b.png";